import { Component, OnInit } from '@angular/core';
import { AuthService, User } from '../../Services/auth.service';
import { AuthApiService } from 'src/app/Services/auth-api.service';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/Services/admin.service';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.css']
})
export class WebsiteComponent implements OnInit {

  isAuthenticated: boolean = false;
  userData: any;
  graphUser: any;
  rolename:string = '';
  userActive:Boolean = true;
  multiRoles:Boolean = false;
  
  constructor(public authService: AuthService, public apiService: AuthApiService,
    public router: Router, public adminservice: AdminService) {
  }

  messages: string[] = [];
  get currentUserJson(): string {
    return JSON.stringify(this.currentUser, null, 2);
  }
  currentUser: User;

  ngOnInit(): void {

    this.authService.getUser().then(user => {
      this.currentUser = user;

      if (user) {
        this.adminservice.GetUserBasicInfo(this.currentUser.profile.oid).subscribe((data: any) => {
          let user_role = data.result.roleName;
          this.multiRoles = data.result.isMultiRoles;
          this.rolename = user_role;
          if(!data.result.isActive){
            this.userActive = false;
            setTimeout(() => {
              this.onLogout();
              return;
            }, 2000);
          }
          localStorage.setItem('role', user_role);
        });
        this.isAuthenticated = true;
      } else {
        this.isAuthenticated = false;
      }
    }).catch(err => this.addError(err));
    console.log(this.rolename);
  }

  clearMessages() {
    while (this.messages.length) {
      this.messages.pop();
    }
  }
  addMessage(msg: string) {
    this.messages.push(msg);
  }
  addError(msg: string | any) {
    this.messages.push('Error: ' + msg && msg.message);
  }

  public onLogin() {
    this.clearMessages();
    this.authService.login().then(data => {
      console.log(data);
    })
      .catch(err => {
        this.addError(err);
      });
  }

  public onCallAPI() {
    this.clearMessages();
    this.apiService.callApi().then(result => {
      this.addMessage('API Result: ' + JSON.stringify(result));
    }, err => this.addError(err));
  }

  public onRenewToken() {
    this.clearMessages();
    this.authService.renewToken()
      .then(user => {
        this.currentUser = user;
        this.addMessage('Silent Renew Success');
      })
      .catch(err => this.addError(err));
  }

  public onLogout() {
    this.clearMessages();
    localStorage.removeItem('role');
    this.authService.logout().catch(err => this.addError(err));
  }

}
